<script setup>
// digitt: DENG-7201 — a label marker is either a hex color (dot) or an emoji.
// `dotClass` lets each call site keep its own dot size/shape; the emoji always
// renders at a readable size.
import { computed } from 'vue';
import { isHexColor } from 'dashboard/helper/labelColor';

const props = defineProps({
  color: {
    type: String,
    default: '',
  },
  dotClass: {
    type: String,
    default: 'size-2 rounded-sm',
  },
});

const isColor = computed(() => isHexColor(props.color));
</script>

<template>
  <span
    v-if="isColor"
    class="flex-shrink-0"
    :class="dotClass"
    :style="{ background: color }"
  />
  <span v-else class="flex-shrink-0 text-base leading-none">{{ color }}</span>
</template>
